import { OnyxTheme } from '.';

export enum OnyxThemePreference {
  LIGHT = OnyxTheme.LIGHT,
  DARK = OnyxTheme.DARK,
  SYSTEM = 'system',
}
